/**
 * Public entry point for the survey expression mini-language. Mirror of
 * `ADP.Surveys.Shared/Evaluation/ExpressionSandbox/ExpressionSandbox.cs`.
 *
 * Grammar, AST, lexer, parser, and interpreter live beside this file. The spec is
 * enforced by parity tests — keep the TS and C# implementations in lock-step.
 */
import { tokenize, ExpressionSyntaxError } from './lexer.js';
import { parse as parseTokens } from './parser.js';
import { evaluate } from './interpreter.js';
import { toBool } from './value-helper.js';
export { ExpressionSyntaxError };
/** Parse source into an AST. Throws {@link ExpressionSyntaxError} on invalid syntax. */
export function parse(source) {
    const tokens = tokenize(source);
    return parseTokens(tokens);
}
export function evaluateBoolean(sourceOrAst, answers) {
    try {
        const ast = typeof sourceOrAst === 'string' ? parse(sourceOrAst) : sourceOrAst;
        return toBool(evaluate(ast, answers));
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=index.js.map